import useTranslation from '~/hooks/useTranslation';
import orderBlockStyles from '~/styles/bookingFlow/order-block.module.css';
import IconCalendar from '~icons/tabler/calendar';

type Props = {
  children: React.ReactNode;
  preStays?: React.ReactNode;
  postStays?: React.ReactNode;
  extraDays?: React.ReactNode;
};

export default function OrderBlocksWrapper({
  children,
  preStays,
  postStays,
  extraDays,
}: Props) {
  const translate = useTranslation();

  return (
    <div>
      <h2 className={orderBlockStyles.orderBlocksWrapperTitle}>
        <IconCalendar />
        {translate('bookingFlow.overview.order_blocks')}
      </h2>

      <div className={orderBlockStyles.orderBlocksWrapper}>
        {extraDays}
        {preStays}
        {children}
        {postStays}
      </div>
    </div>
  );
}
